var map = {
	"./1.png": 1199,
	"./10.png": 8703,
	"./11.png": 4598,
	"./12.png": 7216,
	"./13.png": 6903,
	"./14.png": 6438,
	"./15.png": 4868,
	"./16.png": 2720,
	"./17.png": 7872,
	"./18.png": 4814,
	"./2.png": 4151,
	"./3.png": 3110,
	"./4.png": 9051,
	"./5.png": 2375,
	"./6.png": 6250,
	"./7.png": 7695,
	"./8.png": 9307,
	"./9.png": 8967,
	"./ENGLISH LITERARY SOCIETY.png": 6226,
	"./RedFM_logo.svg.png": 556,
	"./Screenshot 2023-12-24 at 2.46.08 AM.png": 4993,
	"./bereallogo-1024x538-removebg-preview.png": 8459,
	"./bost.png": 7082,
	"./cd21575e-49f5-4b14-9688-919f66e1a781_logo_1000x400_trim.png": 6258,
	"./cropped-logo-6.png": 948,
	"./logo1.png": 6458,
	"./logo2.png": 1637,
	"./sreopost.png": 287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;